export default {
  en: {
    title: 'Great start!',
    subtitle: "We'll check again in a month and compare",
    approximate: 'Approximate — you said very little',
  },
  ru: {
    title: 'Хорошее начало!',
    subtitle: 'Через месяц проверим снова и сравним',
    approximate: 'Оценка приблизительная — ты сказал совсем немного',
  },
  de: {
    title: 'Guter Anfang!',
    subtitle: 'In einem Monat prüfen wir erneut und vergleichen',
    approximate: 'Ungefähr — du hast sehr wenig gesagt',
  },
  pt: {
    title: 'Ótimo começo!',
    subtitle: 'Daqui a um mês testamos de novo e comparamos',
    approximate: 'Aproximado — você falou muito pouco',
  },
  fr: {
    title: 'Beau début !',
    subtitle: 'On refait le test dans un mois pour comparer',
    approximate: 'Approximatif — tu as très peu parlé',
  },
  es: {
    title: '¡Buen comienzo!',
    subtitle: 'En un mes lo volvemos a comprobar y comparamos',
    approximate: 'Aproximado — hablaste muy poco',
  },
};
